import React from "react"

import ClockInPanel from "../containers/clock-in/panel"
import CashPayoutPanel from "../containers/cash-payout-panel"

const SlidingPanels = () => [
  <ClockInPanel key="1"/>,
  <CashPayoutPanel key="2"/>
]

export default SlidingPanels
